<div class="c-box">
  <ion-header>
    <ion-toolbar>
      <ng-container *ngIf="(documentsLevage | documentsLevagesEditablesPipe:documentsLevageHandlingForm:documentsLevageHandlingForm?.value | documentsLevagesEditablesEnCoursPipe) as docsLevages">
        <ion-title mode="md">
          {{ docsLevages | cumulateListsLengthsPipe:documentsModele }} Document{{ (docsLevages | cumulateListsLengthsPipe:documentsModele) > 1 ? 's' : '' }}
        </ion-title>
      </ng-container>
      <ion-button slot="end" (click)="closeModal()" fill="clear" color="dark">
        <ion-icon slot="icon-only" name="close"></ion-icon>
      </ion-button>
    </ion-toolbar>
  </ion-header>
  <div class="c-box-1">
    <ng-container *ngIf="documentsModele.length > 0">
      <ion-list>
        <ion-list-header>
          <ion-label>Documents liés au type de levage</ion-label>
        </ion-list-header>
        <ng-container *ngFor="let documentModele of documentsModele">
          <ion-item>
            <ion-label>{{ documentModele.title }}</ion-label>
            <ion-button slot="end" (click)="onDocumentModeleOpenClick(documentModele)" shape="round">
              voir
            </ion-button>
          </ion-item>
        </ng-container>
      </ion-list>
    </ng-container>

    <ng-container *ngIf="documentsLevageHandlingForm; else DocumentsIntouchables">
      <ion-list>
        <ion-list-header>
          <ion-label>Documents spécifiques à ce levage</ion-label>
        </ion-list-header>
        <ng-container *ngIf="(documentsLevage | documentsLevagesEditablesPipe:documentsLevageHandlingForm:documentsLevageHandlingForm?.value | documentsLevagesEditablesEnCoursPipe) as ls">
          <ng-container *ngFor="let l of ls">
            <ion-item>
              <ion-label>{{ l | getDocumentLevageEditableTitlePipe }}</ion-label>
              <ion-button slot="end" (click)="onEditableDocumentLevageOpenClick(l)" shape="round">
                voir
              </ion-button>
              <ion-button slot="end" (click)="onEditableDocumentLevageDeleteClick(l)" shape="round" color="danger">
                supprimer
              </ion-button>
            </ion-item>
          </ng-container>
        </ng-container>
      </ion-list>
      <ng-container *ngIf="(documentsLevage | documentsLevagesEditablesPipe:documentsLevageHandlingForm:documentsLevageHandlingForm?.value | documentsLevagesEditablesASupprimerPipe) as ls">
        <ng-container *ngIf="ls.length > 0">
          <ion-list>
            <ion-list-header>
              <ion-label>Documents à effacer</ion-label>
            </ion-list-header>
            <ng-container *ngFor="let l of ls">
              <ion-item>
                <ion-label>{{ l | getDocumentLevageEditableTitlePipe }}</ion-label>
                <ion-button slot="end" (click)="onEditableDocumentLevageOpenClick(l)" shape="round">
                  voir
                </ion-button>
                <ion-button slot="end" (click)="onEditableDocumentLevageCancelDeleteClick(l)" shape="round" color="success">
                  annuler suppression
                </ion-button>
              </ion-item>
            </ng-container>
          </ion-list>
        </ng-container>
      </ng-container>
        <ion-item class="ion-margin-vertical">
          <ion-input type="text" placeholder="Nom du document à ajouter" [formControl]="addDocForm"></ion-input>
          <ion-button size="small" (click)="onAddNewDocLevageClick(FileInput)" shape="round" slot="end" [disabled]="addDocForm.invalid">
            .pdf
          </ion-button>
        </ion-item>
      <div id="id-plus-inputs">
        <input #FileInput id="id-user-file-select" type="file" (change)="uploadDocument($event)" accept=".pdf">
      </div>
    </ng-container>

    <ng-template #DocumentsIntouchables>
      <ion-list *ngIf="documentsLevage.length > 0">
        <ion-list-header>
          <ion-label>Documents spécifiques à ce levage</ion-label>
        </ion-list-header>
        <ng-container *ngFor="let documentLevage of documentsLevage">
          <ion-item>
            <ion-label>{{ documentLevage.title }}</ion-label>
            <ion-button slot="end" (click)="onDocumentModeleOpenClick(documentLevage)" shape="round">
              voir
            </ion-button>
          </ion-item>
        </ng-container>
      </ion-list>
    </ng-template>
  </div>
</div>